const ShimmerBanner = () => {
  return (
    <div className='h-32 w-full animate-pulse rounded-lg bg-gray-100'></div>
  );
};

export default ShimmerBanner;
